import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";
import { HERO_IMG } from "../../data/landing";

export const Hero = () => (
  <section className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:py-24">
    <div>
      <h1 className="font-heading text-4xl font-black leading-[1.05] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
        AI HVAC Estimating Software — quote any job in under two minutes.
      </h1>
      <p className="mt-6 text-lg text-slate-600">
        Snap a photo of the unit, tell us about the job, and Fast Estimate writes a polished, line-itemized PDF — ready to hand to the homeowner before you leave the driveway.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link to="/signup"><Button data-testid="hero-signup" className="h-14 w-full rounded-xl bg-indigo-500 px-8 text-lg font-bold hover:bg-indigo-600 sm:w-auto">Start your free trial</Button></Link>
        <Link to="/login"><Button data-testid="hero-signin" variant="outline" className="h-14 w-full rounded-xl border-2 px-8 text-lg font-bold sm:w-auto">Sign in</Button></Link>
      </div>
      <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
        {["No credit card required", "E-signature + PDF included", "Collect deposits on signing"].map((b) => (
          <span key={b} className="flex items-center gap-2 text-sm font-semibold text-slate-600">
            <ShieldCheck className="h-4 w-4 text-indigo-500" /> {b}
          </span>
        ))}
      </div>
      <p data-testid="not-for-you" className="mt-6 text-xs leading-relaxed text-slate-400">
        Not for you if: you need dispatch, scheduling, or invoicing — this is estimating only. Not for shops running more than 10 techs. Not for trades other than HVAC.
      </p>
    </div>
    <div className="relative">
      <img src={HERO_IMG} alt="HVAC technician servicing a residential air conditioner condenser unit" className="h-80 w-full rounded-2xl object-cover shadow-xl lg:h-[28rem]" />
      <div className="absolute -bottom-6 left-4 right-4 rounded-2xl border-2 border-slate-200 bg-white p-5 shadow-2xl sm:left-8 sm:right-8">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-heading font-black text-slate-900">3-Ton AC Replacement</p>
            <p className="text-xs text-slate-500">drafted in 1 min 38s</p>
          </div>
          <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-700">Ready</span>
        </div>
        <div className="mt-3 flex items-baseline justify-between border-t border-slate-100 pt-3">
          <span className="text-sm font-semibold text-slate-500">Estimated total</span>
          <span className="font-heading text-2xl font-black text-indigo-600">$7,840</span>
        </div>
      </div>
    </div>
  </section>
);
